import { useState } from 'react'
import ClassiService from '../services/ClassiService/ClassiService';
import UtilityService from '../services/UtillityServices/UtilityService';
import { alertService } from '../services/AlertService';
import { handleError } from '../model/handleError';

const useClassi = () => {
  const [loadingState, setLoadingState] = useState({
    isLoadingClassi: false,
    isLoadingClassiByParams: false,
    isLoadingClasseCreating: false,
    isLoadingClasseDelete: false,
    isLoadingClasseUpdate: false,
    isLoadingClassiByParamsNoAuth: false,
    isLoadingMaterialiClasse: false,
    isLoadingMaterialiClasseByUserId: false,
    isLoadingUpdateStateClasse: false
  });

  const [modalState, setModalState] = useState({
    showModalCreateClasse: false,
    showModalDeleteClasse: false,
    showModalUpdateClasse: false,
    showModalUpdateStateClasse: false
  });

  const getClassiByParams = async (params) => {
    setLoadingState({ ...loadingState, isLoadingClassiByParams: true });
    try {
      let obj;
      let response = await ClassiService.getClassiByParams(params);
      const res = await response.json();
      const totalRecord = response.headers.get('X-Total-Record');
      obj = {
        data: res,
        count: totalRecord
      }
      return obj
    } catch (err) {
      handleError(err)
      return {
        data: [],
        count: 0
      }
    } finally {
      setLoadingState({ ...loadingState, isLoadingClassiByParams: false });
    }
  }

  const getClassiByParamsNoAuth = async (params) => {
    setLoadingState({ ...loadingState, isLoadingClassiByParamsNoAuth: true });
    try {
      let obj;
      let response = await ClassiService.getClassiByParamsNoAuth(params);
      const res = await response.json();
      const totalRecord = response.headers.get('X-Total-Record');
      obj = {
        data: res,
        count: totalRecord
      }
      return obj
    } catch (err) {
      handleError(err)
    } finally {
      setLoadingState({ ...loadingState, isLoadingClassiByParamsNoAuth: false });
    }
  }

  const getAllClassi = async () => {
    setLoadingState({ ...loadingState, isLoadingClassiByParams: true });
    try {
    
      let response = await ClassiService.getAllClassi();
      const res = await response.json()
      return res;
    } catch (err) {
      handleError(err)
    } finally {
      setLoadingState({ ...loadingState, isLoadingClassiByParams: false });
    }
  }

  const createClasse = async (data) => {
    setLoadingState({ ...loadingState, isLoadingClasseCreating: true });
    try {
      let response = await ClassiService.createClasse(data);
      alertService.success("Classe creata con successo", {autoClose: true});
      setModalState({...modalState, showModalCreateClasse: false });
      return response;
    } catch (error) {
      handleError(error)
    } finally {
      setLoadingState({ ...loadingState, isLoadingClasseCreating: false });
    }
  }

  const deleteClasse = async (id) => {
    try {
      setLoadingState({ ...loadingState, isLoadingClasseDelete: true });
      let response = await ClassiService.deleteClasse(id);
      const res = await response.json();
      alertService.success("Classe eliminata con successo", {autoClose: true});
      setModalState({...modalState, showModalDeleteClasse: false });
      return res;
    } catch (error) {
      handleError(error)
    } finally {
      setLoadingState({ ...loadingState, isLoadingClasseDelete: false });
    }
  }

  const updateClasse = async (data) => {
    try {
      setLoadingState({ ...loadingState, isLoadingClasseUpdate: true });
      let response = await ClassiService.updateClasse(data);
      alertService.success("Classe aggiornata con successo", {autoClose: true});
      setModalState({...modalState, showModalUpdateClasse: false });
      return response;
    } catch (error) {
      handleError(error)
    } finally {
      setLoadingState({ ...loadingState, isLoadingClasseUpdate: false });
    }
  }

  const getMaterialiClasse = async (data) => {
    setLoadingState({ ...loadingState, isLoadingMaterialiClasse: true });
    try {
      let response = await ClassiService.getMaterialiClasse(data);
      return response;
    } catch (error) {
      handleError(error)
    } finally {
      setLoadingState({ ...loadingState, isLoadingMaterialiClasse: false });
    }
  }

  const getMaterialiClasseByUserId = async (data) => {
    setLoadingState({ ...loadingState, isLoadingMaterialiClasseByUserId: true });
    try {
      let response = await ClassiService.getMaterialiClasseByUserId(data);
      return response;
    } catch (error) {
      handleError(error)
    } finally {
      setLoadingState({ ...loadingState, isLoadingMaterialiClasseByUserId: false });
    }
  }

  const updateStateClasse = async (data) => {
    setLoadingState({ ...loadingState, isLoadingUpdateStateClasse: true });
    try {
      let response = await ClassiService.updateStateClasse(data);
      alertService.success("Stato aggiornato con successo", {autoClose: true});
      return response;
    } catch (error) {
      handleError(error)
    } finally {
      setLoadingState({ ...loadingState, isLoadingUpdateStateClasse: false });
    }
  } 

  return {
    loadingStateClassi: loadingState,
    modalStateClassi: modalState,
    setModalStateClassi: setModalState,
    getClassiByParams,
    getClassiByParamsNoAuth,
    getAllClassi,
    createClasse,
    deleteClasse,
    updateClasse,
    getMaterialiClasse,
    updateStateClasse,
    getMaterialiClasseByUserId
  };      
}

export default useClassi;